import React from "react";
import { motion } from "framer-motion";

export function CaravanTabs({ tabs, active, onChange }) {
  return (
    <div role="tablist" data-testid="caravan-tabs" className="flex gap-1 overflow-x-auto bg-[#0A0A0A] border border-neutral-800 rounded-full p-1.5 w-full sm:w-fit [scrollbar-width:none]">
      {tabs.map((t) => {
        const on = active === t.id;
        return (
          <button
            key={t.id}
            role="tab"
            aria-selected={on}
            onClick={() => onChange(t.id)}
            data-testid={`caravan-tab-${t.id}`}
            className={`relative shrink-0 rounded-full px-4 sm:px-5 py-2.5 text-sm transition-colors duration-200 ${on ? "text-[#050505] font-semibold" : "text-neutral-400 hover:text-white"}`}
          >
            {on && <motion.span layoutId="caravan-tab-pill" className="absolute inset-0 rounded-full bg-[#73bf44]" transition={{ type: "spring", bounce: 0.18, duration: 0.45 }} />}
            <span className="relative z-10 flex items-center gap-2">
              <t.icon size={16} weight={on ? "fill" : "regular"} />
              {t.label}
              {t.count != null && (
                <span className={`text-[0.65rem] font-bold min-w-[20px] h-5 px-1.5 rounded-full flex items-center justify-center ${on ? "bg-[#050505]/15" : "bg-neutral-800 text-neutral-300"}`}>
                  {t.count}
                </span>
              )}
            </span>
          </button>
        );
      })}
    </div>
  );
}
